/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { StorageLocation, Effect, Material, Nullable, Blank, InventoryItem, Reference, Setter } from "../../utils/Interfaces";
import { AxiosResponse } from "axios";

export function inventoryIngress(
    storageLocation: StorageLocation,
    material: Material,
    amount: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onInventoryIngressComplete: Setter<number>,
    onInventoryIngressFailed: Effect
) {
    postHandler<Blank, Reference<number>>(
        `/api/inventory/ingress/${storageLocation.id}/${material.id}/${amount}`,
        { notes: notes === "" ? null : notes },
        dispatch,
        (response: AxiosResponse<Reference<number>, any>) => onInventoryIngressComplete(response.data.id),
        stdErrHandlerFactory(dispatch, onInventoryIngressFailed),
        () => {}
    );
}

export function inventoryTransfer(
    fromStorageLocation: StorageLocation,
    toStorageLocation: StorageLocation,
    material: Material,
    amount: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onInventoryTransferComplete: Setter<number>,
    onInventoryTransferFailed: Effect
) {
    postHandler<Blank, Reference<number>>(
        `/api/inventory/transfer/${fromStorageLocation.id}/${toStorageLocation.id}/${material.id}/${amount}`,
        { notes: notes === "" ? null : notes },
        dispatch,
        (response: AxiosResponse<Reference<number>, any>) => onInventoryTransferComplete(response.data.id),
        stdErrHandlerFactory(dispatch, onInventoryTransferFailed),
        () => {}
    );
}

export function inventoryTransferDefective(
    fromStorageLocation: StorageLocation,
    material: Material,
    defectiveType: number,
    serialNumber: string,
    storeNo: string,
    blameId: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onInventoryTransferComplete: Setter<any>,
    onInventoryTransferFailed: Effect
) {
    let payload: { serial_number: string; notes?: string; store_number: string; blame_id: number } = {
        serial_number: serialNumber,
        store_number: storeNo,
        blame_id: blameId,
    };

    if (notes !== null && notes !== "") {
        payload.notes = notes;
    }

    postHandler<Blank, Reference<any>>(
        `/api/inventory/transfer-defective/${fromStorageLocation.id}/${material.id}/${defectiveType}`,
        payload,
        dispatch,
        (response: AxiosResponse<Reference<any>, any>) => onInventoryTransferComplete(response.data),
        stdErrHandlerFactory(dispatch, onInventoryTransferFailed),
        () => {}
    );
}

export function inventoryAdmin(
    inventory: InventoryItem,
    amount: number,
    targetAmount: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onInventoryTransferComplete: Setter<Nullable<number>>,
    onInventoryTransferFailed: Effect
) {
    postHandler<Blank, Reference<Nullable<number>>>(
        `/api/inventory/update/${inventory.id}`,
        {
            amount: amount,
            target: targetAmount,
            notes: notes === "" ? null : notes,
        },
        dispatch,
        (response: AxiosResponse<Reference<Nullable<number>>, any>) => onInventoryTransferComplete(response.data.id),
        stdErrHandlerFactory(dispatch, onInventoryTransferFailed),
        () => {}
    );
}
